import React from 'react'
import { TableCell, TableCellProps, Typography } from '@material-ui/core'
import { useReportStyles } from './report-tab-styles'

type Props = TableCellProps & {
  title: string
}

export function TableHeaderTitleCell({
  title,
  children,
  ...cellProps
}: Props): React.ReactElement {
  const classes = useReportStyles()

  return (
    <TableCell className={classes.tableHeaderTitleCell} {...cellProps}>
      <Typography variant="h6">{title}</Typography>
      {children}
    </TableCell>
  )
}
